const EquipmentMasterApiUrls = {
  GET: `${process.env.REACT_APP_USER_ACI_SHARED_URL}/shared/equipment-master/get`,
  POST: `${process.env.REACT_APP_USER_ACI_SHARED_URL}/shared/equipment-master/create`,
  PUT: `${process.env.REACT_APP_USER_ACI_SHARED_URL}/shared/equipment-master/update`,
  DELETE: `${process.env.REACT_APP_USER_ACI_SHARED_URL}/shared/equipment-master/delete`,
  MASS_DELETE: `${process.env.REACT_APP_USER_ACI_SHARED_URL}/shared/equipment-master/mass-delete`,
  EXPORT: `${process.env.REACT_APP_USER_ACI_SHARED_URL}/shared/equipment-master/download`,
  EXPORT_CSV: `${process.env.REACT_APP_USER_ACI_SHARED_URL}/shared/equipment-master/downloadCSV`,
  UPLOAD : `${process.env.REACT_APP_USER_ACI_SHARED_URL}/shared/equipment-master/upload`
};

export default EquipmentMasterApiUrls
